<template>
    <div class="MsgKnowledgeFileSelect">
        <el-tabs v-if="catalogTree && catalogTree.childrenCatalogList" v-model="currentTab" @tab-click="selectCatalogByName($event.name)">
            <el-tab-pane v-for="item in catalogTree.childrenCatalogList" :key="item.catId" :name="item.catName" :label="item.catName">
                <div slot="label" class="label-item">
                        <div class="label-item-title">{{ item.catName }}</div>
                        <div class="label-item-tip">{{ item.catName==="行业知识库"? '请选择一个文件，进入会话':'请上传一个文件，进入会话' }}</div>
                </div>
                <el-container class="knowledge-container" v-if="item && item.childrenCatalogList">
                    <el-aside class="knowledge-tree-container" width="12em">
                        <div class="tree-title">
                            <span @click="selectCatalogByName(currentTab)">类目</span>
                            <i class="ecp-iconfont ecp-icon-plus" @click="selectCatalogByName(currentTab);newCatalog()"></i>
                        </div>
                        <label-tree
                            :treeList="item.childrenCatalogList"
                            @clickTreeNode="selectCatalog"
                            @handleUploadNode="uploadFile"
                            @handleRemoveNode="deleteCatalog"
                            @handleAddNode="newCatalog"
                            @handleEditNode="renameFolder"
                            :currentTab="currentTab"
                        ></label-tree>
                    </el-aside>
                    <el-main class="knowledge-list-container">
                        <div class="line">
                            <el-breadcrumb v-if="currentCatalog" separator=">">
                                <el-breadcrumb-item>{{currentCatalog.breadLabel}}</el-breadcrumb-item>
                            </el-breadcrumb>
                            <div class="rightplace">
                                <el-radio-group v-model="currentShowStyle" size="small">
                                    <el-radio-button label="img" @cilck="changeShowStyle('img')">
                                        <i class="ecp-iconfont ecp-icon-menu"></i>
                                    </el-radio-button>
                                    <el-radio-button label="list" @cilck="changeShowStyle('list')">
                                        <i class="ecp-iconfont ecp-icon-content-show"></i>
                                    </el-radio-button>
                                </el-radio-group>
                            </div>
                        </div>
                        <el-empty v-if="(!knowledgeList || !knowledgeList.length)"
                                class="upload" :image="require('@/theme/images/knowledge/empty.png')" description="暂无内容，支持文件格式pdf、txt、wav">
                        </el-empty>
                        <template  v-else>
                            <div class="content">
                            <div class="file-content img" v-if="currentShowStyle ==='img'">
                                <div class="card-box">
                                    <div v-for="item in knowledgeList" :key="item.knowledgeId" class="card">
                                        <div class="card-item">
                                            <div class="file-img">
                                                <el-popover trigger="click" placement="bottom-start" :popper-class="isDark?'knowledge-tooltip knowledge-tooltip-dark':'knowledge-tooltip'" class="more-operation">
                                                    <i slot="reference" class="ecp-iconfont ecp-icon-more"></i>
                                                    <div class="operation-button">
                                                        <div  @click="renameFile(item)">重命名</div>
                                                        <div @click="deleteKnowledge(item)">删除</div>
                                                    </div>
                                                </el-popover>
                                                <span class="iconfile" :class="getFileIcon(item.knowledgeName,'big')" @click="selectKnowledge(item)"></span>
                                            </div>
                                            <div class="file-name" :title="item.knowledgeName" @click="selectKnowledge(item)">{{item.knowledgeName}}</div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <ul class="list" v-if="currentShowStyle ==='list'">
                                <template v-for="item in knowledgeList">
                                    <li :key="item.knowledgeId">
                                        <span class="iconfile" :class="getFileIcon(item.knowledgeName,'small')"></span>
                                        <div class="file-name" :title="item.knowledgeName" @click="selectKnowledge(item)">{{item.knowledgeName}}</div>
                                        <el-popover trigger="click" placement="bottom-start" :popper-class="isDark?'knowledge-tooltip knowledge-tooltip-dark':'knowledge-tooltip'" class="more-operation">
                                                <i slot="reference" class="ecp-iconfont ecp-icon-more"></i>
                                                <div class="operation-button">
                                                    <div  @click="renameFile(item)">重命名</div>
                                                    <div @click="deleteKnowledge(item)">删除</div>
                                                </div>
                                        </el-popover>
                                    </li>
                                </template>
                            </ul>
                            </div>
                        </template>
                        </el-main>
                </el-container>
            </el-tab-pane>
        </el-tabs>
        <input ref="upload" class="input-upload" type="file" accept=".txt,.pdf,.mp3,.wav" @change="doUploadToKnowledge">
    </div>
</template>
<script>
import mime from 'mime';
import knowledgeApi from '@/api/knowledge.api.js';
import UploadMixin from '@/app/mixins/UploadMixin.js';
import LabelTree from './components/label-tree.vue';
import { MessageBox } from 'element-ui';
export default {
    name: 'MsgKnowledgeFileSelect',
    mixins: [UploadMixin],
    components: {
        LabelTree
    },
    data () {
        let catalogTree = {};
        let treeProps = {
            children: 'childrenCatalogList',
            label: 'catName'
        };
        let currentTab = null;
        let currentCatalog = null;
        let currentCatalogPath = [];
        let knowledgeList = [];
        let currentShowStyle = 'img';
        return { catalogTree, treeProps, knowledgeList, currentTab, currentCatalog, currentCatalogPath, currentShowStyle };
    },
    props: {
        value: {
            type: Object,
            default: null
        }
    },
    computed: {
        isDark () {
            return this.$store.state.appSettings.isDark;
        }
    },
    async mounted () {
        await this.load();
        this.selectFirstCatalog();
    },
    methods: {
        async load () {
            let ret = await knowledgeApi.getCatalogTree();
            this.catalogTree = ret.data || {};
        },

        getFileIcon (name, type) {
            let mimetype = mime.getType(name);
            if (!mimetype) {
                return 'el-icon-document';
            } else if (mimetype === 'application/pdf') {
                return 'iconfile-pdf-' + type;
            } else if (mimetype.indexOf('text') === 0) {
                return 'iconfile-txt-' + type;
            } else if (mimetype.indexOf('audio') === 0) {
                return 'iconfile-wav-' + type;
            }
        },

        selectFirstCatalog () {
            if (!this.catalogTree || !this.catalogTree.childrenCatalogList) return;
            let catalog = this.catalogTree.childrenCatalogList[0];
            if (!catalog) return;
            this.currentTab = catalog.catName;
            this.selectCatalog(catalog);
        },

        async selectCatalog (node) {
            if (!node) return;
            let { catId, parentCatId, catName, initType, childrenCatalogList, breadLabel } = node;
            this.currentCatalog = { catId, parentCatId, catName, initType, childrenCatalogList, breadLabel };
            let payload = { catId };
            let ret = await knowledgeApi.getKnowledgePage(payload);
            this.knowledgeList = ret.data || [];
        },

        selectCatalogByName (name) {
            if (!this.catalogTree || !this.catalogTree.childrenCatalogList) return;
            let catalog = this.catalogTree.childrenCatalogList.find((item) => {
                return item.catName === name;
            });
            if (!catalog) return;
            this.selectCatalog(catalog);
        },

        selectKnowledge (knowledge) {
            this.$emit('selectKnowledge', knowledge);
        },

        newCatalog () {
            let currentCatalog = this.currentCatalog;
            if (!currentCatalog) {
                this.$message.warning('请选择目录');
                return;
            }
            this.$prompt('请输入目录名称', '新建目录', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                inputPattern: /\S/,
                inputErrorMessage: '目录名称不能为空'
            }).then(async ({ value }) => {
                let payload = {
                    parentCatId: currentCatalog.catId,
                    catName: value,
                    initType: 0
                };
                let ret = await knowledgeApi.addCatalog(payload);
                if (ret.statusCode === 200) {
                    this.$message.success('操作成功');
                    await this.load();
                    await this.selectCatalog(currentCatalog);
                } else {
                    this.$message.error('操作失败');
                }
            });
        },

        /**
         * 上传文件
         */
        uploadFile () {
            let currentCatalog = this.currentCatalog;
            if (!currentCatalog) {
                this.$message.warning('请选择目录');
                return;
            }
            const upload = this.$refs['upload'];
            upload.click();
        },

        /**
         * 上传文件
         */
        async doUploadToKnowledge () {
            let currentCatalog = this.currentCatalog;
            if (!currentCatalog) {
                this.$message.warning('请选择目录');
                return;
            }

            const upload = this.$refs['upload'];
            const file = upload.files[0];
            const name = file.name;
            const mimetype = this.getMimetype(name);

            let url = await this.getFileUrl(file);
            let payload = {
                catId: currentCatalog.catId,
                knowledgeName: file.name,
                knowledgeUrl: url
            };
            if (mimetype && mimetype.indexOf('audio') === 0) payload.useSpeech2Text = 'speech2text'; // 音频文件特殊处理
            let ret = await knowledgeApi.addKnowledge(payload);
            if (ret.statusCode === 200) {
                this.$message.success('操作成功');
                await this.selectCatalog(currentCatalog);
            } else {
                this.$message.error('操作失败');
            }
        },

        /**
         * 删除目录
         */
        async deleteCatalog (catalog) {
            let currentCatalog = this.currentCatalog;
            if (!currentCatalog) {
                this.$message.warning('请选择目录');
                return;
            }

            let catId = catalog.catId;
            MessageBox.confirm('此操作将永久删除该文件夹, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(async () => {
                let ret = await knowledgeApi.deleteCatalog(catId);
                if (ret.statusCode === 200) {
                    this.$message.success('操作成功');
                    await this.load();
                    await this.selectCatalogByName(this.currentTab);
                } else {
                    this.$message.error('操作失败');
                }
            });
        },

        /**
         * 删除知识库
         */
        async deleteKnowledge (knowledge) {
            let currentCatalog = this.currentCatalog;
            if (!currentCatalog) {
                this.$message.warning('请选择目录');
                return;
            }

            let knowledgeId = knowledge.knowledgeId;
            MessageBox.confirm('此操作将永久删除该文件, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(async () => {
                let ret = await knowledgeApi.deleteKnowledge(knowledgeId);
                if (ret.statusCode === 200) {
                    this.$message.success('操作成功');
                    await this.selectCatalog(currentCatalog);
                } else {
                    this.$message.error('操作失败');
                }
            });
        },

        /**
         * 获取文件名的mimetype
         */
        getMimetype (name) {
            return mime.getType(name);
        },
        // 修改文件列表呈现样式
        changeShowStyle (type) {
            this.currentShowStyle = type;
        },
        // 重命名文件
        renameFile (knowledge) {
            let currentCatalog = this.currentCatalog;
            if (!currentCatalog) {
                this.$message.warning('请选择目录');
                return;
            }
            let knowledgeId = knowledge.knowledgeId;
            let knowledgeName = knowledge.knowledgeName;

            this.$prompt('请输入文件名称', '重命名', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                inputPattern: /\S/,
                inputErrorMessage: '文件名称不能为空',
                inputValue: knowledgeName
            }).then(async ({ value }) => {
                let payload = {
                    knowledgeId: knowledgeId,
                    knowledgeName: value
                };
                let ret = await knowledgeApi.updateKnowledge(payload);
                if (ret.statusCode === 200) {
                    this.$message.success('操作成功');
                    await this.load();
                    await this.selectCatalog(currentCatalog);
                } else {
                    this.$message.error('操作失败');
                }
            });
        },
        // 重命名文件夹
        renameFolder (catalog) {
            let currentCatalog = this.currentCatalog;
            if (!currentCatalog) {
                this.$message.warning('请选择目录');
                return;
            }
            let catId = catalog.catId;
            let catName = catalog.catName;
            this.$prompt('请输入文件夹名称', '编辑文件夹', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                inputPattern: /\S/,
                inputErrorMessage: '文件夹名称不能为空',
                inputValue: catName
            }).then(async ({ value }) => {
                let payload = {
                    catId: catId,
                    catName: value
                };
                let ret = await knowledgeApi.updateCatalog(payload);
                if (ret.statusCode === 200) {
                    this.$message.success('操作成功');
                    await this.load();
                    await this.selectCatalog(currentCatalog);
                } else {
                    this.$message.error('操作失败');
                }
            });
        }
    }
};
</script>
<style lang="scss" scoped>
.MsgKnowledgeFileSelect {
    margin-top: 16px;
    margin: 16px 52px 0px 52px;
    .el-tabs{
        ::v-deep{
            .el-tabs__header{
                margin: 0;
            }
            .el-tabs__nav-wrap::after{
                display: none;
            }
            .el-tabs__nav{
                display: flex;
                width: 100%;
                justify-content: center;
            }
            .el-tabs__active-bar{
                display: none;
            }
            .el-tabs__item{
                height: 56px;
                padding: 0;
                .label-item{
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                    color: var(--placeholder-font-color);
                    &-title{
                        font-size: 16px;
                        font-family: PingFang SC-Medium, PingFang SC, SourceHanSansSC-Medium, SourceHanSansSC, Microsoft Yahei;
                        font-weight: 500;
                        line-height: 24px;
                    }
                    &-tip{
                        font-size: 12px;
                        line-height: 17px;
                        padding: 4px 48px;
                    }
                }
            }
            .is-active{
                .label-item{
                    &-title{
                       color: var(--ai-model-classification-font);
                    }
                    &-tip{
                        color: var(--placeholder-font-color-active);
                    }
                    &:before {
                        content: '';
                        position: absolute;
                        left: 0;
                        bottom: 0;
                        width: 100%;
                        height: 4px;
                        background: linear-gradient(270deg, #165DFF 0%, #209BFF 100%);
                    }
                }
            }
        }
    }
    .knowledge-tree-container{
        background: var(--knowledge-left-bg);
        box-shadow: 7px 5px 10px 0px var(--knowledge-leftbox-shadow);
        border-radius: 8px 0px 0px 8px;
        border: 1px solid var(--knowledge-leftbox-border);
        width: 184px;
        height: 480px;
        z-index: 1;
        .tree-title{
            padding: 12px 8px 1px 16px;
            font-size: 14px;
            font-family: PingFang SC-Medium, PingFang SC, SourceHanSansSC-Medium, SourceHanSansSC, Microsoft Yahei;
            font-weight: 500;
            color: var(--knowledge-tree-title-text);
            line-height: 20px;
            display: flex;
            justify-content: space-between;
            align-items: center;
            height: 48px;
            img,span{
                cursor: pointer;
            }
            i{
                cursor: pointer;
                color: var(--ai-model-classification-font);
                font-size: 16px;
            }
        }
    }
    .knowledge-list-container {
        z-index: 0;
        width: calc(100% - 184px);
        height: 480px;
        padding: 0;
        background: var(--knowledge-right-bg);
        border-radius: 0px 8px 8px 0px;
        box-sizing: border-box;
        display: flex;
        flex-direction: column;
        &:before {
            content: '';
            position: absolute;
            left: 0;
            top: 0;
            width: 100%;
            height: 24px;
            border-radius: 0px 8px 0px 0px;
            background:  var(--knowledge-rightbox-shadow);
        }
        .el-empty{
            width: 100%;
            height: 100%;
        }
        .line {
            padding: 16px 16px 8px 16px;
            display: flex;
            align-items: center;
            justify-content: space-between;
            ::v-deep{
                .el-breadcrumb__inner{
                color: var(--knowledge-breadcrumb-text);
                font-size: 12px;
                }
            }
            .el-radio-group{
                ::v-deep{
                    .el-radio-button{
                        .el-radio-button__inner{
                            width: 32px;
                            height: 24px;
                            border-radius: 4px;
                            border: 0 solid #FFF;
                            display: flex;
                            align-items: center;
                            justify-content: center;
                            background: transparent;
                            color: var(--knowledge-radio-button);
                            box-shadow: 0 0 0 #409EFF;
                            .ecp-iconfont{
                                font-size: 16px;
                            }
                        }
                    }
                    .is-active{
                        .el-radio-button__inner{
                            background: var(--knowledge-button-active-bg);
                            color: var(--ai-model-classification-font);
                        }
                    }
                }
            }
        }
        .content{
            height:100%;
            overflow: auto;
            .file-content{
                margin: 0 0 0 10px;
                display: flex;
                flex-direction: column;
                .card-box{
                    display: flex;
                    flex-wrap: wrap;
                    .card{
                        width: 18%;
                        height: 120px;
                        margin-right: 16px;
                        &:nth-child(5n){
                            margin-right: 0;
                        }
                        .card-item{
                            display: flex;
                            flex-direction: column;
                            justify-content: center;
                            align-items: center;
                            .file-img{
                                position: relative;
                                align-items: center;
                                display: flex;
                                width: 72px;
                                height: 72px;
                                background: transparent;
                                .more-operation{
                                    display: none;
                                }
                                .iconfile{
                                    width: 72px;
                                    height: 72px;
                                }
                            }
                        .file-name{
                                font-size: 14px;
                                color: var(--knowledge-text);
                                line-height: 20px;
                                overflow: hidden;
                                text-align: center;
                                text-overflow: ellipsis;
                                display:-webkit-box;
                                -webkit-line-clamp:2;
                                -webkit-box-orient:vertical;
                            }
                            &:hover{
                                .file-img{
                                    background: var(--knowledge-list-hover-bg);
                                    border-radius: 2px;
                                    .more-operation{
                                        position: absolute;
                                        top: 0;
                                        right: 0;
                                        display: block;
                                        i{
                                            cursor: pointer;
                                            color: var(--ai-model-classification-font);
                                            font-size: 16px;
                                        }
                                }
                                }
                                .file-name{
                                    cursor: pointer;
                                }
                        }
                        }
                    }
                }

            }
            .list{
                list-style-type: none;
                padding: 0 16px;
                li{
                    display: flex;
                    align-items: center;
                    height: 32px;
                    padding-left: 16px;
                    border-radius: 4px;
                    .iconfile{
                        margin-right: 8px;
                    }
                    .file-name{
                        font-size: 14px;
                        color: var(--knowledge-text);
                        line-height: 24px;
                        overflow: hidden;
                        text-overflow: ellipsis;
                        white-space: nowrap;
                        flex: 1;
                        margin-right: 16px;
                    }
                    .more-operation{
                        display: none;
                    }
                    &:nth-child(2n){
                        background: var(--knowledge-list-2n-bg);
                    }
                    &:hover{
                        background: var(--knowledge-list-hover-bg);
                        border-radius: 4px;
                        .more-operation{
                            display: block;
                            margin-right: 16px;
                            i{
                                cursor: pointer;
                                color: var(--ai-model-classification-font);
                                font-size: 16px;
                            }

                        }
                    }
                }
            }
        }
    }
    .input-upload{
        display: none;
    }
}
</style>
